var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlertsvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 38,
    height: 38,
    rx: 19,
    fill: "#20A100"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3337 19.5002C27.3337 14.8978 23.6027 11.1668 19.0003 11.1668C14.398 11.1668 10.667 14.8978 10.667 19.5002C10.667 24.1025 14.398 27.8335 19.0003 27.8335C23.6027 27.8335 27.3337 24.1025 27.3337 19.5002Z",
    stroke: "white",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.667 19.9167L17.7503 22L22.3337 17",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertsvg);
export default __webpack_public_path__ + "static/media/alertsvg.e9911132b88153ad7b7145e5159ed9b6.svg";
export { ForwardRef as ReactComponent };